// extracted by mini-css-extract-plugin
export default {"meatball":"risk-matrix-meatball__meatball--TveRx"};